import { styled } from '@mui/system'
import { TTheme } from '@/core/theme'

export const FooterWrapper = styled('div')<{ theme?: TTheme }>`
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px 0 4px;
    border-top: 1px solid ${({ theme }) => theme.colors.semantic.drawerSeparator};
    background-color: ${({ theme }) => theme.colors.semantic.drawerBackground};
`

export const SelectedCountWrapper = styled('div')`
    flex-shrink: 0;
    white-space: nowrap;
`

export const CommentInput = styled('input')<{ theme?: TTheme }>`
    flex: 1;
    min-width: 0;
    height: 40px;
    padding: 8px 14px;
    border: 1px solid ${({ theme }) => theme.colors.greys[300]};
    border-radius: 8px;
    background-color: ${({ theme }) =>
        theme.colors.semantic.backgroundSecondary};
    color: ${({ theme }) => theme.colors.greys[800]};
    font-family: inherit;
    font-size: var(--font-size-s);
    transition: border-color 0.15s ease;

    &::placeholder {
        color: ${({ theme }) => theme.colors.greys[500]};
    }

    &:focus {
        outline: none;
        border-color: ${({ theme }) => theme.colors.primary[400]};
    }

    &:disabled {
        background-color: ${({ theme }) => theme.colors.greys[100]};
        cursor: not-allowed;
    }
`

export const ButtonsWrapper = styled('div')`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
`

export const SecondaryButton = styled('button')<{ theme?: TTheme }>`
    height: 32px;
    padding: 0 18px;
    border: 1px solid transparent;
    border-radius: 16px;
    background-color: ${({ theme }) => theme.colors.greys[100]};
    color: ${({ theme }) => theme.colors.greys[800]};
    font-family: inherit;
    font-size: var(--font-size-s);
    font-weight: var(--font-weight-semibold);
    cursor: pointer;
    transition:
        background-color 0.15s ease,
        border-color 0.15s ease;

    &:hover:not(:disabled) {
        background-color: ${({ theme }) => theme.colors.greys[200]};
    }

    &:disabled {
        color: ${({ theme }) => theme.colors.greys[400]};
        background-color: ${({ theme }) => theme.colors.greys[100]};
        cursor: not-allowed;
    }
`
